import script from "./usb-manage.vue?vue&type=script&setup=true&lang=ts"
export * from "./usb-manage.vue?vue&type=script&setup=true&lang=ts"

import "./usb-manage.vue?vue&type=style&index=0&id=90367aac&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90367aac"]])

export default __exports__